/*
  Viora - Build Your Bundle: keeps the right hidden discount code on the cart.
  Only cart lines added from the bundle page (line property _bundle) count towards a tier.
  Tier codes live in snippets/bundle-code-sync.liquid. If no code is filled in, this file does not load.
*/
(function () {
  var cfg = window.BundleConfig;
  if (!cfg || !cfg.tiers) return;

  var prop = cfg.property || '_bundle';
  var tiers = cfg.tiers
    .filter(function (t) { return t.code; })
    .sort(function (a, b) { return b.qty - a.qty; });
  if (!tiers.length) return;

  var ours = tiers.map(function (t) { return t.code.toUpperCase(); });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function setCode(code) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ discount: code }),
    }).then(function () {
      return getCart();
    });
  }

  function bundleCount(cart) {
    return cart.items.reduce(function (n, item) {
      return item.properties && item.properties[prop] ? n + item.quantity : n;
    }, 0);
  }

  // Codes that are actually taking money off the cart right now.
  function workingCodes(cart) {
    var found = [];
    cart.items.forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        found.push(String(a.discount_application.title || '').toUpperCase());
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      found.push(String(a.title || '').toUpperCase());
    });
    return found;
  }

  // Every code attached to the cart, including one that no longer qualifies.
  function attachedCodes(cart) {
    var found = workingCodes(cart);
    (cart.discount_codes || []).forEach(function (d) {
      found.push(String(d.code || '').toUpperCase());
    });
    return found;
  }

  function hasOurCode(cart) {
    return attachedCodes(cart).some(function (c) { return ours.indexOf(c) !== -1; });
  }

  function run() {
    return getCart().then(function (cart) {
      var n = bundleCount(cart);
      var candidates = tiers.filter(function (t) { return n >= t.qty; });

      if (!candidates.length) {
        if (!hasOurCode(cart)) return false;
        return setCode('').then(function () { return true; });
      }

      // Best tier first. Falls back to a lower tier if a code does not qualify,
      // for example when a bundle item has since been excluded for a sale.
      if (workingCodes(cart).indexOf(candidates[0].code.toUpperCase()) !== -1) return false;

      var i = 0;
      function tryNext() {
        if (i >= candidates.length) return setCode('').then(function () { return true; });
        var code = candidates[i++].code;
        return setCode(code).then(function (updated) {
          if (workingCodes(updated).indexOf(code.toUpperCase()) !== -1) return true;
          return tryNext();
        });
      }
      return tryNext();
    });
  }

  var running = null;
  var again = false;

  function sync() {
    if (running) {
      again = true;
      return running;
    }
    running = run().then(
      function (changed) {
        running = null;
        if (!again) return changed;
        again = false;
        return sync().then(function (c) { return changed || c; });
      },
      function (err) {
        running = null;
        again = false;
        throw err;
      }
    );
    return running;
  }

  // Redraws the cart drawer, cart icon and cart page with the new totals.
  // Do not send an Accept: application/json header here: on a page URL Shopify then
  // returns the page record instead of the requested sections.
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');
    var mainSections = cartItems && cartItems.getSectionsToRender ? cartItems.getSectionsToRender() : [];
    var names = {};

    if (drawer) {
      names['cart-drawer'] = true;
      names['cart-icon-bubble'] = true;
    }
    mainSections.forEach(function (s) { names[s.section] = true; });
    var list = Object.keys(names);
    if (!list.length) return Promise.resolve();

    return fetch(window.location.pathname + '?sections=' + list.join(','))
      .then(function (r) { return r.json(); })
      .then(function (html) {
        function inner(source, selector) {
          var found = new DOMParser().parseFromString(source, 'text/html').querySelector(selector);
          return found ? found.innerHTML : null;
        }
        function fill(el, source, selector) {
          if (!el || !source) return;
          var value = inner(source, selector);
          if (value !== null) el.innerHTML = value;
        }

        if (drawer) {
          fill(document.querySelector('#CartDrawer'), html['cart-drawer'], '#CartDrawer');
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        fill(document.getElementById('cart-icon-bubble'), html['cart-icon-bubble'], '.shopify-section');

        mainSections.forEach(function (s) {
          var wrapper = document.getElementById(s.id);
          if (!wrapper || s.id === 'cart-icon-bubble') return;
          fill(wrapper.querySelector(s.selector) || wrapper, html[s.section], s.selector);
          // The checkout button sits outside the refreshed area of the cart page footer.
          if (s.id === 'main-cart-footer' && html[s.section]) {
            var button = document.getElementById('checkout');
            var next = new DOMParser().parseFromString(html[s.section], 'text/html').querySelector('#checkout');
            if (button && next) button.textContent = next.textContent.trim();
          }
        });
      });
  }

  function syncAndRefresh() {
    return sync()
      .then(function (changed) { return changed ? refresh() : null; })
      .catch(function (e) { console.error('Bundle code sync failed', e); });
  }

  window.BundleCodeSync = { sync: sync, refresh: refresh };

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncAndRefresh);
    }
    syncAndRefresh();
  }

  // This file loads before pubsub.js and constants.js, so wait until every deferred script has run.
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
